export const ColDefs = [
  {
    title: 'PO #',
    dataIndex: 'poNo'
  },
  {
    title: 'PO Qty',
    dataIndex: 'orderQty'
  },
  {
    title: 'PO # of Cartons',
    dataIndex: 'cartonsNo'
  },
  {
    title: 'Customer Name',
    dataIndex: 'clientName'
  },
  {
    title: 'Customer PO#',
    dataIndex: 'clientPONo'
  }
];
